import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import ApiClient from "../../api";
import { createError, HTTPErrors } from "../../errors";
import { getNextPageParam } from "../../helpers/ReactQueryHelper";
import ApiResponse from "../../interfaces/ApiResponse";
import { StayInterface } from "../../interfaces/StayInterface";
import { useOnMainScrollAreaScroll } from "../useMainScrollAreaScroll";

type Props = {
  sectionId: string;
};
type ResponseBody = ApiResponse<StayInterface[]>;
export const useFetchSectionStayingStudents = (props: Props) => {
  const path = baseUrl(props.sectionId);
  const result = useInfiniteQuery<ResponseBody, HTTPErrors>({
    queryKey: [path],
    queryFn: async ({ pageParam }) => {
      const response = await ApiClient.get(path, {
        query: { page: pageParam },
      });
      if (response.ok) {
        const json = await response.json();
        return json.stays as ResponseBody;
      }
      throw await createError(response);
    },
    initialPageParam: 1,
    getNextPageParam,
  });

  useOnMainScrollAreaScroll(() => {
    if (!result.isLoading && !result.isFetchingNextPage && result.hasNextPage) {
      result.fetchNextPage();
    }
  }, [result.hasNextPage, result.isLoading, result.isFetchingNextPage]);

  const data = useMemo(
    () => result.data?.pages.flatMap((page) => page.data),
    [result],
  );
  return { ...result, data };
};

const baseUrl = (sectionId: string) =>
  `/api/v1/sections/${sectionId}/stays/staying_students`;
